<template>
	<div id="ranking">
		<ul class="ranking">
			<li v-if="showInvit" :class="{active:(listIndex == 0)}" @click="change(0)">邀请榜</li>
			<li v-if="showReward" :class="{active:(listIndex == 1)}" @click="change(1)">打赏榜</li>
			<li v-if="showSale" :class="{active:(listIndex == 2)}" @click="change(2)">分销榜</li>
			<!-- <li :class="{active:(listIndex == 3)}" @click="change(3)">学校榜</li>
			<li :class="{active:(listIndex == 4)}" @click="change(4)">班级榜</li> -->
		</ul>

		<div class="lists">
			<!--邀请榜-->
			<div class="list" v-if="showInvit" v-show="listIndex == 0">
				<van-pull-refresh v-model="isLoading">
					<template v-if="leads.length">
						<van-list v-model="Invitloading"  :finished="Invitfinished"  finished-text="没有更多了"  @load="loadInvitation">
							<ul class="leads">
								<li v-for="(item,index) in leads" :key="index" v-if="index < 3">
							       	<div class="headimg">
									    <img v-if="index == 0" class="image-top" :src="imgPath+'list/no1_top.png'"/>
									    <img v-if="index == 1" class="image-top" :src="imgPath+'list/no2_top.png'"/>
									    <img v-if="index == 2" class="image-top" :src="imgPath+'list/no3_top.png'"/>
							
									    <img :src="item.header" class="image">
							
									    <img v-if="index == 0" class="image-bottom" :src="imgPath+'list/no1_bottom.png'"/>
									    <img v-if="index == 1" class="image-bottom" :src="imgPath+'list/no2_bottom.png'"/>
									    <img v-if="index == 2" class="image-bottom" :src="imgPath+'list/no3_bottom.png'"/>
							   	    </div>
							   	    <div class="nick">{{item.nick}}</div>
							        <p>邀请<span> {{item.total}} </span>位好友</p>
								</li>
								<div class="leftimg"></div>
								<div class="rightimg"></div>
							</ul>
							<div class="leadlist" v-for="(item,index) in leads" :key="index" v-if="index > 2">
								<div class="shu">
									<span v-if="item.fans_id == fans_id" class="self">{{index+1}}</span>
									<span v-else>{{index+1}}</span>
								</div>
								<div class="image"><img :src="item.header" :alt="item.nick"></div>
								<div class="nick ellipsis">{{item.nick}}</div>
								<p class="ellipsis">邀请<span> {{item.total}} </span>位好友</p>
							</div>
					   </van-list>
					</template>
					<div v-else class="nothing">
				        <img :src="imgPath+'nothing.png'">
				    </div>
				</van-pull-refresh>
			</div>

			<!--打赏榜-->
			<div class="list" v-if="showReward" v-show="listIndex == 1">
				<van-pull-refresh v-model="isRewardLoading">
					<template v-if="leadsRe.length">
						<ul class="leads">
							<li v-for="(item,index) in leadsRe" :key="index" v-if="index < 3">
		                       	<div class="headimg">
								    <img v-if="index == 0" class="image-top" :src="imgPath+'list/no1_top.png'"/>
								    <img v-if="index == 1" class="image-top" :src="imgPath+'list/no2_top.png'"/>
								    <img v-if="index == 2" class="image-top" :src="imgPath+'list/no3_top.png'"/>

								    <img :src="item.header" class="image">

								    <img v-if="index == 0" class="image-bottom" :src="imgPath+'list/no1_bottom.png'"/>
								    <img v-if="index == 1" class="image-bottom" :src="imgPath+'list/no2_bottom.png'"/>
								    <img v-if="index == 2" class="image-bottom" :src="imgPath+'list/no3_bottom.png'"/>
		                   	    </div>
		                   	    <div class="nick">{{item.nick}}</div>
						        <p>打赏<span> {{item.top_money/100}} </span>元</p>
							</li>
							<div class="leftimg"></div>
							<div class="rightimg"></div>
						</ul>
						<div class="leadlist" v-for="(item,index) in leadsRe" :key="index" v-if="index > 2">
							<div class="shu"><span>{{index+1}}</span></div>
							<div class="image"><img :src="item.header" :alt="item.nick"></div>
							<div class="nick ellipsis">{{item.nick}}</div>
							<p class="ellipsis">打赏<span> {{item.top_money/100}} </span>元</p>
						</div>
					</template>
					<div v-else class="nothing">
				        <img :src="imgPath+'nothing.png'">
				    </div>
				</van-pull-refresh>
			</div>

			<!--分销榜-->
			<div class="list" v-if="showSale" v-show="listIndex == 2">
				<van-pull-refresh v-model="isSaleLoading">
					<template v-if="leadsSa.length">
						<ul class="leads">
							<li v-for="(item,index) in leadsSa" :key="index" v-if="index < 3">
		                       	<div class="headimg">
								    <img v-if="index == 0" class="image-top" :src="imgPath+'list/no1_top.png'"/>
								    <img v-if="index == 1" class="image-top" :src="imgPath+'list/no2_top.png'"/>
								    <img v-if="index == 2" class="image-top" :src="imgPath+'list/no3_top.png'"/>

								    <img :src="item.header" class="image">

								    <img v-if="index == 0" class="image-bottom" :src="imgPath+'list/no1_bottom.png'"/>
								    <img v-if="index == 1" class="image-bottom" :src="imgPath+'list/no2_bottom.png'"/>
								    <img v-if="index == 2" class="image-bottom" :src="imgPath+'list/no3_bottom.png'"/>
		                   	    </div>
		                   	    <div class="nick">{{item.nick}}</div>
						        <p>累计获利<span> {{item.total/100}} </span>元</p>
							</li>
							<div class="leftimg"></div>
							<div class="rightimg"></div>
						</ul>
						<div class="leadlist" v-for="(item,index) in leadsSa" :key="index" v-if="index > 2">
							<div class="shu"><span>{{index+1}}</span></div>
							<div class="image"><img :src="item.header" :alt="item.nick"></div>
							<div class="nick ellipsis">{{item.nick}}</div>
							<p class="ellipsis">累计获利<span> {{item.total/100}} </span>元</p>
						</div>
					</template>
					<div v-else class="nothing">
				        <img :src="imgPath+'nothing.png'">
				    </div>
				</van-pull-refresh>
			</div>


			<!--学校排名榜-->
			<div class="list" v-show="listIndex == 3">
				<van-pull-refresh v-model="isSchoolLoading">
					<template v-if="schoolData.length">
						<div class="leadlist" v-for="(item,index) in schoolData" :key="index">
							<div class="shu">
								<img style="width:25px;margin-top:6px;" v-if="index == 0" src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/one1.png">
								<img style="width:25px;margin-top:6px;" v-else-if="index == 1" src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/two1.png">
								<img style="width:25px;margin-top:6px;" v-else-if="index == 2" src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/three1.png">
								<span v-else-if="index>2&&index<5" style="background:#ff9503">{{index+1}}</span>
								<span v-else>{{index+1}}</span>
							</div>
							<div class="nick ellipsis" style="padding-left:5px;">{{item.school}}</div>
							<p class="ellipsis">进来<span> {{item.count}} </span>位学生</p>
						</div>
					</template>
					<div v-else class="nothing">
				        <img :src="imgPath+'nothing.png'">
				    </div>
				</van-pull-refresh>
			</div>

           <!-- 班级排名 -->
			<div class="list" v-show="listIndex == 4">
				  <van-pull-refresh v-model="isClassLoading">
					<template v-if="classData.length">
						<div class="leadlist" v-for="(item,index) in classData" :key="index">

							<div class="shu">
								<img style="width:25px;margin-top:6px;" v-if="index == 0" src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/one1.png">
								<img style="width:25px;margin-top:6px;" v-else-if="index == 1" src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/two1.png">
								<img style="width:25px;margin-top:6px;" v-else-if="index == 2" src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/three1.png">
								<span v-else-if="index>2&&index<10" style="background:#ff9503">{{index+1}}</span>
								<span v-else>{{index+1}}</span>
							</div>
							<div class="nick ellipsis" style="padding-left:5px;">{{item.school+item.grade+item.class}}</div>
							<p class="ellipsis">进来<span> {{item.count}} </span>位学生</p>
						</div>
					</template>
					<div v-else class="nothing">
				        <img :src="imgPath+'nothing.png'">
				    </div>
				  </van-pull-refresh>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import vxxData from '../../../kits/data.js';
import { Toast } from 'vant';
import tool from '../../../kits/Tools.js';
import { PullRefresh } from 'vant';
Vue.use(PullRefresh);
import { List } from 'vant';
Vue.use(List);

	export default {
		data() {
			return {
				showInvit:false,
				showReward:false,
				showSale:false,
				ds_id:'',
				listIndex:-1,
				leads: [], //邀请榜
				leadsRe: [], //贡献榜
				leadsSa: [], //分销榜
				schoolData:[],//学校榜
				classData:[],//班级榜
				isLoading: false,
				isRewardLoading: false,
				isSaleLoading: false,
				isSchoolLoading:false,
				isClassLoading:false,
				loaded:false,
				imgPath:'',
				Invitloading:false,
				Invitfinished:false,
				InvitCurrPage:1
			}
		},
		props:['toplist','currentMid','mid','fans_id'],
		mounted(){
			this.ds_id = tool.getQueryDsId();
			this.imgPath = tool.imgPath();
		},
		watch: {
			isLoading(){
			    if(this.isLoading){
					this.InvitCurrPage = 1;
			     	this.loadInvitation();
			    }
			},
			isRewardLoading(){
				if(this.isRewardLoading){
					this.loadReward();
				}
			},
			isSchoolLoading(){
                if(this.isSchoolLoading){
					// this.loadSchool();
				}
			},
			isClassLoading(){
                if(this.isClassLoading){
					// this.loadSchool();
				}
			},
			currentMid(){
				var that = this;
				if(!this.loaded && this.currentMid == this.mid){
					Toast.loading({
						mask: true,
						message: '加载中...'
					});
					console.log(that.toplist)
					if(that.toplist != null){
						for(let i =0;i< that.toplist.length;i++){
						if(that.toplist[i] == 'invite_top'){
							that.showInvit = true;
							this.listIndex = 0;
							that.loadInvitation();
						}else if(that.toplist[i] == 'reward_top'){
							that.showReward = true;
							if(this.listIndex != 0){
								this.listIndex = 1;
							}
							that.loadReward();
						}else if(that.toplist[i] == 'sale_top'){
							that.showSale = true;
							if(this.listIndex != 1 && this.listIndex != 0){
								this.listIndex = 2;
							}
							that.loadSale();
						}else{
							console.log('');
						}
					  }
					}
					
					// if(this.listIndex == -1){
     //                   this.listIndex = 3;
					// }
					//curretn
					// that.loadSchool();
				}
				//current
			}
		},
		methods: {
			change(num){
				this.listIndex = num;
			},
			loadInvitation() {
				//获取邀请帮数据
				var that = this;
				var url = tool.baseUrl1()+'/wap/index/invite';
				var option = 'ds_id='+ this.ds_id+'&page_nums=20'+'&page='+this.InvitCurrPage;
				this.axios.post(url,option).then(function(res){
					var data = res.data;
					Toast.clear();
					if(data.code == "200") {
						that.isLoading = false;
						if(that.InvitCurrPage>1){
							that.leads = that.leads.concat(data.data);
						}else{
							that.leads = data.data;
						}
						
						that.loaded = true;
						console.log(data.data)
						that.InvitCurrPage++;
						that.Invitloading = false;
						if(data.data.length == 0){
							that.Invitfinished = true;
						}
					}else{
						console.log(data.message);
					}
				}).catch(function(res){
					console.log(res);
				})
			},
			loadReward() {
				//获取邀请帮数据
				var that = this;
				var url = tool.baseUrl1()+'/wap/index/reward';
				var option = 'ds_id='+ this.ds_id+'&page_nums=1000';
				this.axios.post(url,option).then(function(res){
					var data = res.data;
					Toast.clear();
					if(data.code == "200") {
						that.isRewardLoading = false;
						that.leadsRe = data.data;
						that.loaded = true;
					}else{
						console.log(data.message);
					}
				}).catch(function(res){
					console.log(res);
				})
			},
			loadSale() {
				//获取邀请帮数据
				var that = this;
				var url = tool.baseUrl1()+'/shop/top/lists';
				var option = 'ds_id='+ this.ds_id+'&fans_id='+this.fans_id;
				this.axios.post(url,option).then(function(res){
					var data = res.data;
					Toast.clear();
					if(data.code == "200") {
						that.isSaleLoading = false;
						that.leadsSa = data.data;
						that.loaded = true;
					}else{
						console.log(data.message);
					}
				}).catch(function(res){
					console.log(res);
				})
			},
			loadSchool(){
				var that = this;
				var url =tool.baseUrl3()+'/infoCollection/rankList';
				var option = 'ds_id='+ this.ds_id+'&fans_id='+this.fans_id;
				this.axios.post(url,option).then(function(res){
					var data = res.data;
					Toast.clear();
					if(data.code == "200") {
						that.isSchoolLoading = false;
						that.isClassLoading = false;
						that.schoolData =  data.data.schoolList;
						that.classData  =  data.data.classList;
						that.loaded = true;
					}else{
						console.log(data.message);
					}
				}).catch(function(res){
					console.log(res);
				})
			},
			onInvitLoad(){
				console.log("onInvitLoad");
			}
		}
	}
</script>

<style scoped>
#ranking{
	overflow-x: hidden
}
.lists{
	height: 100%;
    padding-top: 64px;
    margin-top: -64px;
    box-sizing: border-box;
}
.list{
	height: 100%;
	overflow-y: scroll;
}
.ranking{
	text-align: center;
	padding: 20px 0;
	font-size: 0;
}
.ranking li{
    padding:6.5px 27px;
    font-size:15px;
    font-weight: bold;
    color: #333333;
    background: #FFFFFF;
    display: inline-block;
    box-shadow: 0 2px 4px 0px #dadada;
}
.ranking li.active{
    color: white;
    background: #fd9427;
}
.headimg{
	position: relative;
	height: 60px;
}
.image-top{
 	position: absolute; 
 	width: 45px;
 	margin-left:-22px;
 	height: 20px;
 	left: 50%;
 	top: -10px;
}
.image-bottom{
 	position: absolute; 
 	width: 66px;
 	height: 12px;
 	left:50%;
 	top: 42px;
 	margin-left: -33px;
}
.leads .nick{
 	font-size: 16px;
 	color: #333333;
 	max-height: 42px;
 	overflow: hidden;
}
.leads{
 	position: relative;
 	text-align: center;
 	height:152px;
 	margin-bottom: 20px;
 	background: #fff;
 	margin-top: 40px;
}
.leads li{
 	position: absolute;
 	width: 33.3%;
 	top: 20px;
 	padding: 20px 0 10px;
 	background: #fff;
}
.leads li:first-child{
   top:-40px;
 	left: 33.3%;
}
.leads li:nth-child(2){
 	left: 0;
 	top: -20px;
}
.leads li:nth-child(2) .image{
 	border-color: #d5d5d5;
}
.leads li:nth-child(3){
 	top: 0;
 	left: 66.6%;
}
.leads li:nth-child(3) .image{
	border-color: #ffae99;
}
.leads li p{
 	color: #999;
}
.leads li span{
 	color: #ff9503;
}
.leads .image{
 	width:50px;
 	height:50px;
 	border: 2px #fff042 solid;
 	border-radius:50%;
 	box-sizing: border-box;
 	position: absolute;
 	top: 0px;
 	left: 50%;
 	margin-left: -25px;
}
.leftimg{
	position: absolute;
	top: -20px;
	left: 33.3%;
	height: 0;
	width: 0;
	border-top: 80px solid #eee;
	border-right: 2px solid #eee;
	border-left: 2px solid transparent;
	border-bottom:80px solid transparent;
	margin-left: -4px;
}
.rightimg{
	position: absolute;
	top: 0px;
	left: 66.6%;
	height: 0;
	width: 0;
	border-top: 80px solid #eee;
	border-left: 2px solid #eee;
	border-right: 2px solid transparent;
	border-bottom:80px solid transparent;
}
.leadlist{
 	display: flex;
 	padding: 15px 10px;
 	height: 40px;
 	line-height: 40px;
}
.leadlist:nth-child(2n+1){
 	background: #f7f7f7;
}
.leadlist:nth-child(2n){
 	background: #fff;
}
.leadlist .shu{
 	width: 30px;
 	text-align: center;
}
.leadlist .shu span{
  	display: inline-block;
  	border-radius: 50%;
  	width:20px;height: 20px;
  	line-height: 20px;
  	background: #c7c7c7;
  	font-size: 12px;
  	color: #fff;
  	margin-top: 10px;
}
.leadlist .shu span.self{
	background: #ff9503;
}
.leadlist .image{
 	flex:3;
 	text-align: center;
}
.leadlist .image img{
 	width: 40px;height: 40px;border-radius: 20px;
}
.leadlist .nick{
 	flex:7;
}
.leadlist p{
 	flex:5;
 	text-align: right;
 	padding-right: 10px;
}
.leadlist p span{
  	color: #ff9503;
}
</style>